import React, { useRef } from "react";
import { useClickOutside } from "../../../hooks/useClickOutside";
import "./FolderPickerPopover.css";

export interface FolderOption {
  id: number;
  chat_folder_name: string;
}

interface FolderPickerPopoverProps {
  isOpen: boolean;
  anchorRef: React.RefObject<HTMLElement | null>;
  folders: FolderOption[];
  onClose: () => void;
  onSelect: (folderId: number) => void;
}

const FolderPickerPopover: React.FC<FolderPickerPopoverProps> = ({
  isOpen,
  anchorRef,
  folders,
  onClose,
  onSelect,
}) => {
  const popoverRef = useRef<HTMLDivElement>(null);

  // Close on outside click
  useClickOutside([popoverRef, anchorRef], onClose, isOpen);

  // Position to the right of the anchor element
  const getStyle = (): React.CSSProperties => {
    if (!anchorRef.current) return {};
    const rect = anchorRef.current.getBoundingClientRect();
    return {
      top: rect.top,
      left: rect.right + 8,
    };
  };

  if (!isOpen) return null;

  return (
    // Stop propagation on the container so clicks inside the popover
    // don't bubble up to the SessionItem's onClick (which would open the chat)
    <div ref={popoverRef} className="folder-picker-popover"
      style={getStyle()}
      onClick={(e) => e.stopPropagation()}
    >

      <div className="folder-picker-header">
        <span className="folder-picker-title">Move to folder</span>
        <button className="folder-picker-close" onClick={(e) => { e.stopPropagation(); onClose(); }}>
          <i className="fas fa-times" />
        </button>
      </div>

      <div className="folder-picker-list">
        {folders.length === 0 ? (
          <div className="folder-picker-empty">
            <i className="fas fa-folder-open" />
            <span>No folders yet</span>
          </div>
        ) : (
          folders.map((f) => (
            <button
              key={f.id}
              className="folder-picker-item"
              onClick={(e) => {
                e.stopPropagation(); // prevent bubbling to SessionItem's onClick
                onSelect(f.id);
                onClose();
              }}
            >
              <i className="fas fa-folder" />
              <span>{f.chat_folder_name}</span>
            </button>
          ))
        )}
      </div>

    </div>
  );
};

export default FolderPickerPopover;